import styled from '@emotion/styled';
import { ob } from '../../onboardingV2.tokens';

export const Tile = styled.button`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 100%;
    min-height: 144px;
    padding: 16px;
    border: 1.5px dashed
        ${({ invalid, dragActive }) => {
            if (invalid) return ob.color.error;
            return dragActive ? ob.color.brand : ob.color.border;
        }};
    border-radius: ${ob.radius.md};
    background: ${({ dragActive }) => (dragActive ? ob.color.lime50 : ob.color.subtle)};
    font-family: ${ob.font.body};
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    transition:
        border-color ${ob.motion.fast},
        background ${ob.motion.fast};

    ${ob.hover} {
        &:hover {
            border-color: ${ob.color.brand};
            background: ${ob.color.lime50};
        }
    }

    &:focus-visible {
        outline: none;
        box-shadow: ${ob.focusRing};
    }

    &:disabled {
        cursor: progress;
    }
`;

export const TileIcon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    margin-bottom: 4px;
    border-radius: 50%;
    background: ${ob.color.lime100};
    color: ${ob.color.brand};

    i {
        font-size: 24px;
    }
`;

export const TileTitle = styled.span`
    font-size: 15px;
    font-weight: 600;
    color: ${ob.color.body};
`;

export const TileHint = styled.span`
    font-size: 13px;
    color: ${ob.color.muted};

    @media (pointer: coarse) {
        display: none;
    }
`;

export const Preview = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 12px;
    border: 1.5px solid ${ob.color.borderSubtle};
    border-radius: ${ob.radius.md};
    background: ${ob.color.surface};
`;

export const Thumb = styled.div`
    position: relative;
    flex-shrink: 0;
    width: 104px;
    height: 104px;
    border-radius: 12px;
    overflow: hidden;
    background: ${ob.color.subtle};

    img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export const Optimizing = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    background: ${ob.color.overlay};
    color: ${ob.color.brand};
    font-size: 12px;
    font-weight: 600;
    text-align: center;

    i {
        font-size: 20px;
    }
`;

export const PreviewSide = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;
`;

export const FileName = styled.span`
    max-width: 100%;
    margin-bottom: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    color: ${ob.color.muted};
`;

export const Actions = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-left: -12px;
`;
